import Status from 'clarks/components/ivu-table/status'

let forms = {
   
}

let tables = {
   service_list: {
      props: {
         icon: 'fa fa-database',
         title: 'Service List',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['service', 'db_collection', 'created_at', 'action', 'checksum', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Service", key: "service", },
            { title: "Db Collection", key: "db_collection", },
            { title: "Created At", key: "created_at", },
            { title: "Action", key: "action", },
            { title: "Checksum", key: "checksum", },

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'service_list:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'service_list:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}